import { change } from 'redux-form';

import {
  changeFieldValueAndUpdate,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { ThunkResult } from 'app/store/helpers';
import { selectQuotation } from 'app/store/data/quotation';
import {
  VehicleTypeEnum,
  FormsEnum,
  FieldsEnum,
  SortingCriterionEnum,
  MessagesEnum,
} from 'app/shared/enums';
import { QuotationConfigActions } from 'app/store/data/quotationConfig';
import { getPromotion, PromotionActions } from 'app/store/data/promotion';
import { PromotionCodeService } from 'app/services/promotionCode.service';
import { isMubiLeasingActive } from 'app/services/env.service';
import { getLastQuotation } from 'app/store/data/quotation/thunks';
import { FormsConfigActions } from 'app/store/data/formsConfig';
import { ShortPathDataActions } from '../data/shortPathData';

const clearPromotionCode = (quotationId: string) =>
  PromotionCodeService.setPromotionCode(
    quotationId,
    null,
    null,
    null,
    null,
    null
  );

export const onVehicleTypeChange = (value: VehicleTypeEnum): ThunkResult => (
  dispatch,
  getState
) => {
  const state = getState();
  const quotation = selectQuotation(state);
  const promotion = getPromotion(state);

  dispatch(FormsConfigActions.setVehicleTypeChanged(true));
  dispatch(ShortPathDataActions.clearCepikData());

  dispatch(getLastQuotation(value, quotation.userId))
    .then(() => {
      dispatch(QuotationConfigActions.setIsVehicleTypeChanged(true));

      dispatch(
        change(
          FormsEnum.OfferFilters,
          FieldsEnum.Sort,
          SortingCriterionEnum.PriceAsc
        )
      );

      if (isMubiLeasingActive) {
        setMessageVisibility({
          key: MessagesEnum.NoInsuranceForVehicleInLeasing,
          visible:
            !!quotation.legalStatus?.leased &&
            quotation.vehicleType === VehicleTypeEnum.Motorcycle,
          formName: FormsEnum.CalculationForm,
        });
      }

      if (promotion.code) {
        dispatch(PromotionActions.clearPromotion());
        clearPromotionCode(quotation.id);
      }
    })
    .catch(() => {
      const switchVehicleType = () => {
        changeFieldValueAndUpdate(FieldsEnum.VehicleType, value);
        dispatch(QuotationConfigActions.setIsVehicleTypeChanged(true));
      };

      if (promotion.code) {
        clearPromotionCode(quotation.id)
          .then(() => {
            switchVehicleType();
            dispatch(PromotionActions.clearPromotion());
            dispatch(PromotionActions.markPromotionAsExpired(promotion.code!));
          })
          .catch(switchVehicleType);
      } else {
        switchVehicleType();
      }
    });
};
